import { makeRedirectToSelector } from "@client/content/selectors";
import { createSelector } from "reselect";
import { type LinkType } from "../component";

export const makeLinkTypeSelector = (target: string, prefix?: string) => {
  const redirectToSelector = makeRedirectToSelector(target, prefix);

  return createSelector([redirectToSelector], (redirectTo): LinkType | undefined => {
    if (!redirectTo) return;

    switch (redirectTo.type) {
      case "lightbox": {
        //if (redirectTo.url && redirectTo.url.match("(jpg|jpeg|png)$")) return "gallery_link_type";

        return "lightbox_link_type";
      }
      case "step":
      case "tab":
      case "popup":
      case "url":
        return redirectTo.newTab ? "new_window_link_type" : "regular_link_type";
    }
  });
};
